import {
  ActionType,
  ActionWidget,
  FileHelper,
  FormFieldWidget,
  FormM2OUploadFieldWidget,
  FormStringUploadFieldWidget,
  ModelFieldType,
  SPI,
  ViewActionTarget,
  ViewType,
  Widget,
  useUploadFileEvent
} from '@kunlun/dependencies';
const model = ['deli.aries.major.DeliAriesBatchPartnerRelation', 'deli.aries.major.DeliAriesBatchBasicInfo']
import { formTableImportV2 } from '../formTableImportV2/formTableImportV2';
import { uploadService, type upLoadFile } from './UploadService';
@SPI.ClassFactory(
  ActionWidget.Token({
    widget: 'FormTableImportV2',
    actionType: [ActionType.View],
    target: [ViewActionTarget.Dialog, ViewActionTarget.Router, ViewActionTarget.Inner],
    model: model
  })
)
export class SaveImportAttachment extends formTableImportV2 {
  public initialize(config) {
    super.initialize(config);
    return this;
  }
  public async afterClick(e) {
    await useUploadFileEvent({
      file: e,
      onSuccess: (res: upLoadFile) => {
        this.changeFileFiled(res);
      },
      onError: (err) => {
        console.log(err);
      },
      onProgress: () => { }
    });
    super.afterClick(e);
  }
  public changeFileFiled(res: upLoadFile) {
    // 通知服务
    uploadService.notifyFileUploaded({ value: res, model: this.model.model });
  }
}


@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Detail],
    ttype: ModelFieldType.String,
    widget: ['Upload'],
    model: ['deli.aries.seller.DeliAriesSellerBatchDistributor'],
  })
)
export class SaveImportUploadField extends FormStringUploadFieldWidget {
  public initialize(config) {
    super.initialize(config);
    // 注册回调
    uploadService.registerCallback((file) => {
      if (file.model === 'deli.aries.major.DeliAriesBatchPartnerRelation' && this.field.name === 'partnerRelationFileUrl') {
        this.change({ ...file.value, type: "FILE", uid: FileHelper.generateFileId() });
      }
      if (file.model === 'deli.aries.major.DeliAriesBatchBasicInfo' && this.field.name === 'basicInfoFileUrl') {
        this.change({ ...file.value, type: "FILE", uid: FileHelper.generateFileId() });
      }
    });
    return this;
  }
  @Widget.Watch('formData.partnerRelations')
  private watchTableDataOfPartnerRelations() {
    /**合作关系*/
    const partnerRelationsArr = this.formData?.partnerRelations as any ?? []
    if (partnerRelationsArr?.length === 0) {
      if (this.field.name === 'partnerRelationFileUrl') {
        this.change({});
      }
    }
  }
  @Widget.Watch('formData.basicInfos')
  private watchTableDataAfter() {
    /**基础信息*/
    const basicInfosArr = this.formData?.basicInfos as any ?? []
    if (basicInfosArr?.length === 0) {
      if (this.field.name === 'basicInfoFileUrl') {
        this.change({});
      }
    }
  }
}